// import "./App.css";
// import { Routes, Route, Navigate } from "react-router-dom";

import Dashboard from "./components/Dashboard/Dashboard";
import EntrepreneurshipTool from "./components/EntrepreneurshipTool/EntrepreneurshipTool";
import HRTool from "./components/HRTool/HRTool";
import MarketingTool from "./components/MarketingTool/MarketingTool";
import AccountingFinanceTool from "./components/AccountingFinanceTool/AccountingFinanceTool";
import BusinessFundingTool from "./components/BusinessFundingTool/BusinessFundingTool";
import OrganizationalBehaviourTool from "./components/OrganizationalBehaviourTool/OrganizationalBehaviourTool";
import EthicsTool from "./components/EthicsTool/EthicsTool";
import EcommerceTool from "./components/E-commerceTool/E-commerceTool";
import FreelanceTool from "./components/FreelanceTool/FreelanceTool";

// function App() {
//   return (
//     <>
//       <Routes>
//         <Route path="/" element={<Dashboard />} />

//         <Route
//           path="/entrepreneurship-tool"
//           element={<EntrepreneurshipTool />}
//         />
//         <Route path="/hr-tool" element={<HRTool />} />

//         <Route path="/marketing-tool" element={<MarketingTool />} />

//         <Route
//           path="/accounting-finance-tool"
//           element={<AccountingFinanceTool />}
//         />

//         <Route
//           path="/business-funding-tool"
//           element={<BusinessFundingTool />}
//         />

//         <Route
//           path="/organizational-behaviour-tool"
//           element={<OrganizationalBehaviourTool />}
//         />

//         <Route path="/ethics-tool" element={<EthicsTool />} />

//         <Route path="/ecommerce-tool" element={<EcommerceTool />} />

//         <Route path="/freelance-tool" element={<FreelanceTool />} />
//       </Routes>
//     </>
//   );
// }

// export default App;

import React, { useState, useContext, createContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginModal from "./components/LoginModal/LoginModal";
import Comparison from "./components/Comparison/Comparison";
import Training from "./components/Training/Training";
// Import other components similarly

// Authentication context
export const AuthContext = createContext(null);

const useAuth = () => useContext(AuthContext);

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const login = (username, password) => {
    // Here, validate against your backend or static credentials
    // Simplified example with static check
    if (
      username === process.env.REACT_APP_USERNAME &&
      password === process.env.REACT_APP_PASSWORD
    ) {
      setUser({ username });
    }
  };

  const logout = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

// Protected route component
function PrivateRoute({ children }) {
  // const auth = useAuth();

  // if (!auth.user) {
  //   // If not logged in, show login
  //   return <LoginModal />;
  // }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/comparison" element={<Comparison />} />
        <Route path="/training" element={<Training />} />

        <Route
          path="/entrepreneurship-tool"
          element={
            <PrivateRoute>
              <EntrepreneurshipTool />
            </PrivateRoute>
          }
        />

        <Route
          path="/entrepreneurship-tool"
          element={
            <PrivateRoute>
              {" "}
              <EntrepreneurshipTool />
            </PrivateRoute>
          }
        />
        <Route
          path="/hr-tool"
          element={
            <PrivateRoute>
              <HRTool />{" "}
            </PrivateRoute>
          }
        />

        <Route
          path="/marketing-tool"
          element={
            <PrivateRoute>
              <MarketingTool />{" "}
            </PrivateRoute>
          }
        />

        <Route
          path="/accounting-finance-tool"
          element={
            <PrivateRoute>
              <AccountingFinanceTool />{" "}
            </PrivateRoute>
          }
        />

        <Route
          path="/business-funding-tool"
          element={
            <PrivateRoute>
              <BusinessFundingTool />{" "}
            </PrivateRoute>
          }
        />

        <Route
          path="/organizational-behaviour-tool"
          element={
            <PrivateRoute>
              <OrganizationalBehaviourTool />
            </PrivateRoute>
          }
        />

        <Route
          path="/ethics-tool"
          element={
            <PrivateRoute>
              <EthicsTool />
            </PrivateRoute>
          }
        />

        <Route
          path="/ecommerce-tool"
          element={
            <PrivateRoute>
              <EcommerceTool />
            </PrivateRoute>
          }
        />

        <Route
          path="/freelance-tool"
          element={
            <PrivateRoute>
              <FreelanceTool />
            </PrivateRoute>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
